import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHyperlink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13.549 2.451a4.96 4.96 0 0 0-7.014 0L5.203 3.783l1.414 1.414L7.95 3.865a2.96 2.96 0 0 1 4.186 4.186l-1.332 1.332 1.414 1.414 1.332-1.332a4.96 4.96 0 0 0 0-7.014M3.867 7.947l1.33-1.329-1.415-1.414-1.329 1.329a4.96 4.96 0 0 0 7.014 7.014l1.329-1.328-1.415-1.415-1.328 1.329a2.96 2.96 0 1 1-4.186-4.186"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9.412 5.174 5.176 9.41l1.414 1.414 4.236-4.236z"
	})]
});
export default SvgHyperlink;
